@if (discountCode(); as discount) {
  @if (discount.showBanner && discount.code) {
    <nc-banner
      [centered]="centered()"
      [topMargin]="topMargin()"
      [bottomMargin]="bottomMargin()"
      [isTest366]="isTest366()"
      [text]="
        discount.bannerText || ('discount-banner-default-text' | translate: { code: discount.code })
      "
    />
  }
}
